import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'chainStores';
export const chainStoresActions = makeActions(MODEL_NAME, 'id', 'chain-stores');

export const getAllChainStores = chainStoresActions.getAll;
export const editChainStores = chainStoresActions.edit;
export const createChainStores = chainStoresActions.create;
export const getByIdChainStores = chainStoresActions.getDataById;
